<template>
    <div class="blankBox">
        <div class="blank">
            <img src="../assets/img/blanking.png" />
            <p class="iconfont">功能建设中，敬请期待...</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px){
	.blank{
		width: 100%;
		height: 547px;
	}
}
@media screen and (min-width: 1445px) {
    .blank{
        width: 1200px;
		height: 750px;
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .blank{
        width: 1100px;
		height: 750px;
    }
}
// 空白页
.blankBox{
    width: 100%;
    background-color: #fafafa;
    padding: 30px 0;
}
.blank{
    background-color: #ffffff;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
        width: 407px;
        height: 253px;
    }
    p{
        font-size: 24px;
        color: rgba(25,25,26,0.20);
        margin-top: 22px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/TobeDeveloped.vue